import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconReplay"><Path d="M12 2.5C17.2465 2.50026 21.5 6.75346 21.5 12C21.5 17.2465 17.2465 21.4997 12 21.5C7.1309 21.4998 3.11872 17.8371 2.56543 13.1162L4.55176 12.8838C4.98843 16.6088 8.15734 19.4998 12 19.5C16.1419 19.4997 19.5 16.142 19.5 12C19.5 7.85803 16.1419 4.50026 12 4.5C9.32996 4.50014 6.98386 5.89553 5.6543 8H8.5V10H2.5V4H4.5V6.16895C6.23736 3.93737 8.95041 2.50012 12 2.5Z" fill="currentColor"/><Path d="M15.25 12L10.25 15.25V8.75L15.25 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReplay;
